export const MerchantParams = {
  ORGANIZATION_CODE: 'organizationCode',
  BALANCE: 'balance',
};
